module.exports = __webpack_public_path__ + "img/30.368cf12e.jpg";